import React, { ChangeEvent, ReactNode, Ref, RefObject } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { InputText } from 'primereact/inputtext';
import { Labelled, LabelledProps } from './Labelled';

interface LabelledInputTextProps extends LabelledProps {
  value: string;
  onChange: (value: string) => void;
  pattern?: string;
  autoFocus?: boolean;
  className?: string;
  placeholder?: string;
  hidden?: boolean;
  ref?: RefObject<any>;
  isNew?: boolean;
}

export const LabelledInputText = (props: LabelledInputTextProps): ReactNode => {
  const intl: IntlShape = useIntl();
  const disabled: boolean = (props.permissions ? !props.permissions.canWrite : false) || props.disabled;
  return (
    <Labelled {...props}>
      <InputText
        id={props.id}
        ref={props.ref}
        value={props.value || ""}
        required={props.permissions?.required || props.required}
        invalid={!disabled && (props.validation ? !props.validation?.valid : false)}
        disabled={disabled}
        onChange={(e: ChangeEvent<HTMLInputElement>): void => props.onChange(e.target.value)}
        tooltip={(props.validation && !props.validation?.valid && props.validation.reason) ? props.validation.reason.split(';').map((reason: string): string => intl.formatMessage({id: reason})).join('; ') : undefined}
        tooltipOptions={{position: 'bottom'}}
        pattern={props.pattern}
        autoFocus={props.autoFocus}
        className={props.className + `${props.hidden ? ' opacity-0' : ''} ${props.isNew ? ' border-primary-500 border-3' : ''}`}
        placeholder={props.placeholder}
      />
    </Labelled>
  );
};
